import makeStyles from "@mui/styles/makeStyles";

export const useStepBStyles = makeStyles({
  headline: {
    fontSize: 116,
    fontWeight: 500,
    ["@media screen and (max-width: 2050px)"]: {
      fontSize: "5.7vw",
    },
    ["@media screen and (max-width: 1024px)"]: {
      fontSize: "7vw",
    },
    ["@media screen and (max-width: 850px), screen and (max-height: 650px)"]: {
      fontSize: "10vw",
    },
    ["@media screen and (max-aspect-ratio: 3/2)"]: {
      ["@media screen and (max-width: 850px)"]: {
        fontSize: "10.1vw",
      },
      ["@media screen and (max-width: 650px)"]: {
        fontSize: "9.9vw",
      },
      ["@media screen and (max-width: 500px)"]: {
        fontSize: "9.7vw",
      },
      ["@media screen and (max-width: 400px)"]: {
        fontSize: "9.5vw",
      },
      ["@media screen and (max-width: 350px)"]: {
        fontSize: "9.3vw",
      },
      ["@media screen and (max-width: 280px)"]: {
        fontSize: "26px",
      },
    },
    ["@media screen and (min-aspect-ratio: 3/2)"]: {
      ["@media screen and (max-height: 650px)"]: {
        fontSize: "12vh",
      },
      ["@media screen and (max-height: 500px)"]: {
        fontSize: "13.4vh",
      },
      ["@media screen and (max-height: 300px)"]: {
        fontSize: "12.7vh",
      },
      ["@media screen and (max-height: 280px)"]: {
        fontSize: "35px",
      },
    },
  },
});
